import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { QueryService } from '../comun/services/query.service';
import { Title } from '@angular/platform-browser';
import { GlobalConstants } from '../global-constants';
import { FuncionesService } from '../comun/services/funciones.service';
//import { switchMap, tap, finalize } from 'rxjs/operators';
import { GeoService } from '../comun/services/geo.service';
import Swal from 'sweetalert2';
//import { forkJoin } from 'rxjs';
import { ImagePopupService } from '../comun/services/image-popup.service';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsuarioPerfil } from '../comun/models/misdatos.model';
import { MisdatosService } from '../comun/services/misdatos.service';
import { PerfilService } from '../comun/services/perfil.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css'
})
export class PerfilComponent implements OnInit, OnDestroy {
  @Input() userid: number = 0;
  private misdatosSub!: Subscription;
  private misdatosInicializados = false;
  misdatos: any = {};
  perfil: any = {};
  busy: number = 0;
  selectedFiles: any = { imagenes: [], previewUrl: [] };
  online: boolean = false;
  getgeo: boolean = false;
  editandoperfil: boolean = false;

  constructor(private query: QueryService,
              private titleService: Title,
              public imagepopup: ImagePopupService, 
              private http: HttpClient,
              public geoService: GeoService,
              public funciones: FuncionesService,
              private misdatosService: MisdatosService,
              private perfilService: PerfilService
              ) {}

  ngOnInit() {
    this.titleService.setTitle('iGuau perfil');
    this.checkOnline(this.userid);
    this.getMisDatos();
  }

  ngOnAfterViewInit() {
    this.imagepopup.init();
  }

  getMisDatos() {
    ++this.busy;
    // 1. Escuchamos el observable perfil$
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is UsuarioPerfil => misdatos !== null)
      )
      .subscribe((misdatos: UsuarioPerfil) => {
        // La suscripción emite tanto al iniciar como tras cada guardado.
        // No decrementar busy en cada emisión: podría quedar negativo y
        // ocultar la foto mediante *ngIf="!app.busy".
        const primeraCarga = !this.misdatosInicializados;
        this.misdatos = misdatos;
        if (primeraCarga) {
          this.misdatosInicializados = true;
          this.busy = Math.max(0, this.busy - 1);
          this.selectedFiles.imagenes.length = 0;
          this.selectedFiles.previewUrl.length = 0;
          this.getPerfil();
        } else if (Number(this.userid) === Number(misdatos.ID)) {
          // Refrescar solo el perfil propio, sin repetir el proceso de
          // inicialización ni emitir otra vez en MisdatosService.
          this.perfil = misdatos;
          this.perfilService.setPerfil(this.perfil);
          this.titleService.setTitle('iGuau perfil ' + this.perfil.first_name);
        }        
      });
  }

  /** Notifica los cambios del perfil conectado sin perder su fotografía. */
  publicarMisDatosPerfil(datos: any): void {
    if (!datos || Number(datos.ID) !== Number(this.misdatos?.ID)) return;
    const fotoNueva = datos.foto;
    const fotoActual = this.misdatos?.foto;
    const fotoNuevaValida = fotoNueva && (
      fotoNueva.foto_principal_thumb || fotoNueva.foto_principal_grande
    );
    const actualizado = {
      ...this.misdatos,
      ...datos,
      foto: fotoNuevaValida ? fotoNueva : (fotoActual || fotoNueva)
    };
    this.misdatosService.setMisDatos(actualizado);
  }

  /** Actualiza datos del usuario conectado con la misma consulta que utiliza perfil-show. */
  refrescarMisDatos(): void {
    const id = this.misdatos?.ID;
    if (!id) return;
    this.query.query('misdatos', 'GET', { ID: id }).subscribe({
      next: (datos: any) => this.publicarMisDatosPerfil(datos),
      error: (error: any) => console.error('No se pudo actualizar misdatos tras guardar el perfil', error)
    });
  }

  ngOnDestroy() {
    // Es buena práctica desuscribirse para evitar fugas de memoria
    this.misdatosSub?.unsubscribe();
  }

  getPerfil() {
    // Usuario conectado
    if (Number(this.userid) === Number(this.misdatos.ID)) {
      this.perfil = this.misdatos;
      // Guardamos los datos en el servicio para reutilizarlo en otros componentes
      this.perfilService.setPerfil(this.perfil);
      this.titleService.setTitle('iGuau perfil ' + this.perfil.first_name);
      //this.checkRolPerfil();
      this.checkUserNew();
    // Otro perfil de usuario
    } else {
      ++this.busy;
      this.query.query('misdatos', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
        this.perfil = resultado;
        // Guardamos los datos en el servicio para reutilizarlo en otros componentes
        this.perfilService.setPerfil(this.perfil);
        this.titleService.setTitle('iGuau perfil ' + this.perfil.first_name);
        //this.checkRolPerfil();
        this.checkUserNew();
        this.visitarPerfil();
        // Distancia
        this.perfil.distancia = this.funciones.getDistanceFromLatLon(this.misdatos.geolatitud, this.misdatos.geolongitud, this.perfil.geolatitud, this.perfil.geolongitud);
        --this.busy;
      });
    }
  }

  checkRolPerfil() {
    if (this.misdatos.ID == this.perfil.ID && this.misdatos.rol_perfil == '') {
      Swal.fire({
        title: 'Aviso',
        text: '¿Qué tipo de perfil deseas tener? Selecciona el rol que mejor se adapte a ti',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'custom-swal-confirm',
          /*cancelButton: 'custom-swal-cancel'*/
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = GlobalConstants.urlServer + 'opciones';
        } else {
        }
      });
    }
  }

  checkUserNew() {
    /*if (this.misdatos.user_new && this.misdatos.ID == this.perfil.ID && this.misdatos.rol_perfil != '') {
      this.editarPerfil();
      this.query.query('misdatos', 'QUITAUSERNEW', null).subscribe((resultado:any) => {
      });
    }*/
  }

  checkOnline(userId: number) {
    this.http.get<any>(
      GlobalConstants.urlServer + `wp-json/custom/v1/user-online/${userId}`
    ).subscribe(res => {
      this.online = res.online;
    });
  }

  /*async permisoGeolocalizacion(check: boolean = true) {
    if (this.userid != this.misdatos.ID)
      return;

    const checkGeo = this.checkLocalPermisoUbicacion();
    if (checkGeo == 'si' || checkGeo == null || check == false) {
      const permiso = await this.geoService.checkPermission();

      // Si el usuario a permitido
      if (permiso === 'granted') {
        this.obtenerUbicacionExacta();
      // Permiso denegado pregunta si quiere reintentar
      } else if (permiso === 'denied') {
        this.preguntaReintentarUbicacion();
      // No lo ha permitido o espera la pregunta
      } else {
        this.obtenerUbicacionAproximada();
        this.preguntaUsarUbicacion();
      }
    } else {
      this.obtenerUbicacionAproximada();
    }
  }

  obtenerUbicacionExacta() {
    this.getgeo = true;
  
    this.geoService.getExactPosition().pipe(
      switchMap(position => {
        this.misdatos.geolatitud = position.coords.latitude;
        this.misdatos.geolongitud = position.coords.longitude;

        return this.geoService.getGeo(
          this.misdatos.geolatitud,
          this.misdatos.geolongitud
        );
      }),
      finalize(() => this.getgeo = false)
    )
    .subscribe({
      next: datos => {
        if (datos.barrio != this.misdatos.barrio) {
          this.misdatos.ciudad = datos.city;
          this.misdatos.estado = datos.state;
          this.misdatos.pais = datos.country;
          this.misdatos.cdpostal = datos.postcode;
          this.misdatos.barrio = datos.barrio;
          this.query.query('misdatos', 'SAVE', this.misdatos).subscribe((resultado:any) => {
            this.misdatos.editando = false;
            this.refrescarMisDatos();
          });
        }
        this.setLocalPermisoUbicacion(true);
      },
      error: err => {
        this.misdatos.ciudad = 'Ubicación no disponible';        
      }
    });
  }

  obtenerUbicacionAproximada() {
    // Primero usamos IP (sin popup)
    this.geoService.getApproximatePosition().subscribe(datos => {
      if (datos.city != this.misdatos.ciudad) {
        this.misdatos.ciudad = datos.city;
        this.misdatos.estado = datos.region;
        this.misdatos.pais = datos.country;
        this.misdatos.cdpostal = datos.postcode;
        this.misdatos.barrio = '';
        this.query.query('misdatos', 'SAVE', this.misdatos).subscribe((resultado:any) => {
          this.misdatos.editando = false;
          this.refrescarMisDatos();
        });
      }
    });
  }
  
  preguntaUsarUbicacion() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sí, permitir',
      cancelButtonText: 'No, gracias',
      timer: 0, // No se cierra automáticamente
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      },
      customClass: {
        popup: '',
        confirmButton: 'btn btn-sm btn-success me-2',
        cancelButton: 'btn btn-sm btn-danger'
      },
      buttonsStyling: false
    });

    Toast.fire({
      icon: 'question',
      title: '¿Nos dejas usar tu ubicación?',
      text: 'Para ofrecerte una mejor experiencia y mostrarte perfiles cerca de tu zona, necesitamos acceder a tu ubicación exacta. Esto nos permitirá sugerirte personas y servicios más relevantes y cercanos. ¿Deseas permitir que usemos tu ubicación?'
    }).then((result) => {
      if (result.isConfirmed) {
        this.obtenerUbicacionExacta();
      } else if (result.isDismissed) {
        this.setLocalPermisoUbicacion(false);
      }
    });
  }

  preguntaReintentarUbicacion() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Reintentar',
      cancelButtonText: 'No, gracias',
      timer: 0, // No se cierra automáticamente
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      },
      customClass: {
        popup: '',       // Sombra para destacar
        confirmButton: 'btn btn-sm btn-success me-2',
        cancelButton: 'btn btn-sm btn-danger'
      },
      buttonsStyling: false
    });

    Toast.fire({
      icon: 'question',
      title: '¿Nos dejas usar tu ubicación?',
      text: 'Tienes bloqueada la ubicación. Para activarla haz clic en el candado de la barra de direcciones, permisos, cambia Ubicación a "Permitir" y finalmente haz clic en el botón "Reintentar"'
    }).then((result) => {
      if (result.isConfirmed) {
        this.permisoGeolocalizacion();
      } else if (result.isDismissed) {
        this.setLocalPermisoUbicacion(false);
      }
    });
  }

  setLocalPermisoUbicacion(allow: boolean) {
    localStorage.setItem('permisoUbicacion' + this.misdatos.ID, allow ? 'si' : 'no');    
  }
  checkLocalPermisoUbicacion(): string | null {
    return localStorage.getItem('permisoUbicacion' + this.misdatos.ID); // 'si', 'no' o null si no existe
  }  
 */
  editarPerfil() {
    this.subirScroll();
    this.editandoperfil = true;
  }

  subirScroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  visitarPerfil() {
    this.query.query('visita', 'VISITAR', { ID: this.perfil.ID }).subscribe((resultado:any) => {      
    });
  }

}
